// eslint-disable-next-line import/prefer-default-export
export enum Mutations {
  SET_TOKEN = 'set-token',
  SET_AUTHENTICATED = 'set-authenticated',
  SET_USER = 'set-user',
  SET_COMPANY = 'set-company',
  SET_COMPANY_DATA = 'set-company-data',
}
